import React, { memo, useState } from 'react'
import { Box, Button, Container, Typography } from '@material-ui/core'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import { reverse } from 'named-urls'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'

import { Form, ResendEmail } from './components'

import useClientPortalTheme from 'hooks/useClientPortalTheme'

import useStyles from './styles'
import { routes } from 'Routes'
import constants from 'constants/index'

const TwoFactorAuthenticationMain = ({ match }) => {
  const { PLATFORM_SLUG_ID } = constants.settings

  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const { slug } = useParams()
  const location = useLocation()
  const { instance } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  const { clientPortalTheme } = useClientPortalTheme()
  const classes = useStyles({ clientPortalTheme })()

  const accessToken = match.params.accessToken

  const handleBack = () => {
    if (isAuthenticated) {
      instance.logoutRedirect({
        onRedirectNavigate: () => {
          return false
        },
      })
    }
    history.push(reverse(routes.root, { slug: slug || PLATFORM_SLUG_ID }))
  }
  return (
    <Box className={classes.root}>
      <Container maxWidth="sm">
        <Typography variant="h4" color="textPrimary" className={classes.title}>
          Enviamos um código de verificação no seu e-mail{' '}
          <strong className={classes.highlightedText}>
            {location.state?.email}
          </strong>
        </Typography>

        <Form accessToken={accessToken} setLoading={setLoading} />
        <ResendEmail accessToken={accessToken} />

        <Box mt={3} className={classes.actionButtons}>
          <Button
            onClick={handleBack}
            variant="outlined"
            size="large"
            fullWidth
            className={classes.buttonBack}
          >
            Voltar
          </Button>
          <Button
            type="submit"
            variant="contained"
            size="large"
            fullWidth
            className={classes.buttonPrimary}
            form="2fa-form"
            disabled={loading}
          >
            {loading ? 'Carregando...' : 'Acessar'}
          </Button>
        </Box>
      </Container>
    </Box>
  )
}

TwoFactorAuthenticationMain.propTypes = {
  match: PropTypes.object.isRequired,
}

export default memo(TwoFactorAuthenticationMain)
